import axios, { AxiosInstance } from 'axios';
import { apiUrl, authTitle, hash } from '../config';

class Api {
  public api: AxiosInstance;

  constructor() {
    const token = localStorage.getItem(`@${authTitle}:token`);

    this.api = axios.create({
      baseURL: `https://api-global-v2.encontrodigital.com.br/${hash}`,
    });

    if (token) {
      this.api.defaults.headers.Authorization = `Bearer ${token}`;
    }
  }
}

export default new Api().api;
